export default __webpack_public_path__ + "static/media/logo.9c278e64.png";